import initAnchorLinks from './AnchorLinks/anchorLinks';
import initContentBreadcrumb from './ContentBreadcrumb/ContentBreadcrumb';
import initLeftMenu from './LeftMenu/leftmenu';
import initSearchButton from './Search/SearchButton';

export default function () {
    initLeftMenu();
    initSearchButton();
    initContentBreadcrumb();
    // after the breadcrumb, which decides the light/dark variant both share
    initAnchorLinks();
}
